module.exports = __webpack_public_path__ + "img/Fox.aaa7a20.png";